<div class="header-main-user">
    <core-helper-navigation-user-menu-header (click)="toggleUserMenu()" [open]="!closed"
        [user]="session.current.user"></core-helper-navigation-user-menu-header>
</div>

<div class="header-dropdown"  *ngIf="show" [ngClass]="{'dropmenu-opened': !closed, 'dropmenu-closed': (closed&&initialized)}" > 
    <div class="nav-dropdown">
        <strong class="arrow-shadow"><em>Select</em></strong>

        <ul *ngIf="menu.length > 0">
            <li *ngFor="let m of menu" class="tw2-dropdown-nav-li {{m.class}}">
                <a [routerLink]="[m.link]" (click)="itemMobileAction()">{{m.name}}</a>
            </li>
        </ul>
        <ul>
            <li class="tw2-dropdown-nav-li tw2-drop-sign-out tw2-action-logout">
                <span (click)="logout($event)">Sign out</span>
            </li>
        </ul>
        <div *ngIf="showChangeOrg">
            <select (change)="changeOrg()" [(ngModel)]="selectedOrg">
                <option *ngFor="let org of session.current.organizations" [value]="org.id" [selected]="selectedOrg">
                    {{org.name}}
                </option>
            </select>
        </div>
    </div>
</div>